"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const olympus_1 = require("olympus");
const auth_1 = __importDefault(require("./auth"));
const customer_1 = __importDefault(require("./customer"));
const v1_1 = __importDefault(require("./delivery/v1"));
const location_1 = __importDefault(require("./location"));
const mobile_app_1 = __importDefault(require("./mobile-app"));
const special_hours_1 = __importDefault(require("./special-hours"));
__exportStar(require("olympus"), exports);
/**
 * @deprecated Please use generated client
 */
class OwnClient {
    instance;
    client;
    /**
     * @deprecated Please use generated client
     */
    locationAPI;
    /**
     * @deprecated Please use generated client
     */
    customerAPI;
    /**
     * @deprecated Please use generated client
     */
    deliveryAPI;
    /**
     * @deprecated Please use generated client
     */
    authAPI;
    /**
     * @deprecated Please use generated client
     */
    specialHoursAPI;
    /**
     * @deprecated Please use generated client
     */
    mobileAppAPI;
    constructor({ getRequestSettings, onError, baseURL, guestAudience = 'mercury:guest', defaultHeaders, }) {
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...defaultHeaders,
        };
        const onResponseError = async (err) => {
            if (axios_1.default.isAxiosError(err) && onError) {
                const shouldIgnore = await onError(err);
                if (shouldIgnore) {
                    const cancelErr = new axios_1.default.Cancel('User logged out');
                    if (Error.captureStackTrace) {
                        Error.captureStackTrace(cancelErr, axios_1.default.Cancel);
                    }
                    return await Promise.reject(cancelErr);
                }
            }
            return await Promise.reject(err);
        };
        this.client = (0, olympus_1.createClient)(baseURL, async () => await getRequestSettings(), { defaultHeaders, onResponseError });
        this.instance = axios_1.default.create({
            baseURL,
            headers,
            withCredentials: true,
        });
        this.instance.interceptors.response.use((res) => res, onResponseError);
        this.instance.interceptors.request.use(async (req) => {
            const { audience, client, csrfToken, bearerToken } = await getRequestSettings();
            if (audience) {
                req.headers['X-PB-Audience'] =
                    req.headers?.['X-PB-Audience'] ?? audience;
            }
            if (client) {
                req.headers['X-PB-Client'] = req.headers?.['X-PB-Client'] ?? client;
            }
            if (csrfToken) {
                req.headers['X-CSRFToken'] = req.headers?.['X-CSRFToken'] ?? csrfToken;
            }
            if (bearerToken) {
                req.headers.authorization = req.headers?.Authorization
                    ? [`Bearer ${bearerToken}`, req.headers?.Authorization].join(', ')
                    : `Bearer ${bearerToken}`;
            }
            return req;
        });
        this.locationAPI = new location_1.default(this);
        this.customerAPI = new customer_1.default(this);
        this.deliveryAPI = {
            v1: new v1_1.default(this),
        };
        this.authAPI = new auth_1.default(this, guestAudience);
        this.specialHoursAPI = new special_hours_1.default(this);
        this.mobileAppAPI = new mobile_app_1.default(this);
    }
    /**
     * Performs a GET request
     *
     * @param path URI component
     * @param params URL query params
     * @param config custom axios config
     * @returns an API request promise
     */
    async get(path, params, config) {
        const { data } = await this.instance.get(path, {
            params,
            ...config,
        });
        return data;
    }
    /**
     * Performs a DELETE request
     *
     * @param path URI component
     * @param params URL query params
     * @param config custom axios config
     * @returns an API request promise
     */
    async delete(path, params, config) {
        const { data } = await this.instance.delete(path, {
            params,
            ...config,
        });
        return data;
    }
    /**
     * Performs a POST request
     *
     * @param path URI component
     * @param params API request body
     * @param config custom axios config
     * @returns an API request promise
     */
    async post(path, params, config) {
        const res = await this.instance.post(path, params, config);
        return res.data;
    }
    /**
     * Performs a PUT request
     *
     * @param path URI component
     * @param params API request body
     * @param config custom axios config
     * @returns an API request promise
     */
    async put(path, params, config) {
        const { data } = await this.instance.put(path, params, config);
        return data;
    }
    /**
     * Performs a PATCH request
     *
     * @param path URI component
     * @param params API request body
     * @param config custom axios config
     * @returns an API request promise
     */
    async patch(path, params, config) {
        const { data } = await this.instance.patch(path, params, config);
        return data;
    }
}
__exportStar(require("./auth/types"), exports);
__exportStar(require("./location/types"), exports);
__exportStar(require("./mobile-app/types"), exports);
__exportStar(require("./types"), exports);
exports.default = OwnClient;
//# sourceMappingURL=index.js.map